module.exports = __webpack_public_path__ + "bojan_round-91b28e154b81425bce363e99559e1894.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/bojan_round.png
// module id = 1191
// module chunks = 1 2